import { JobBookingStatus } from '@src/constants/JobBookingStatus';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  jobId: string;
  availabilityId: string;
  status: string;
}

interface Result {
  status: JobBookingStatus;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/job/save_availability_status',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveJobActivityLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveJobActivityLazy;
